var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sent-email-listing" },
    [
      _vm.isLoading
        ? _c("TableLoading")
        : [
            _c(
              "div",
              { staticClass: "sent-email-listing__select-all" },
              [
                _c("CompassCheckbox", {
                  attrs: {
                    modelValue: true,
                    label: _vm.$t.__("common.actions.select_all"),
                    checked: _vm.selectedEmails.length === _vm.emails.length,
                    indeterminate: _vm.isCheckboxIndeterminate
                  },
                  on: { change: _vm.handleCheckAll }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("EmailListingTable", {
              staticClass: "sent-email-listing__table",
              attrs: {
                columns: _vm.columns,
                emails: _vm.emails,
                selectedEmails: _vm.selectedEmails
              },
              on: {
                "open:related": _vm.handleOpenLinkObjectDialog,
                "update:checkedEmails": _vm.handleCheckEmails
              }
            })
          ],
      _vm._v(" "),
      _vm.pagination.total > 0
        ? _c("EmailListingPagination", {
            attrs: {
              isLoading: _vm.isLoading,
              pagination: _vm.pagination,
              displayTotalResults: false
            },
            on: { "update-pagination": _vm.updatePagination }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("EmailsListingMassActions", {
        attrs: {
          selectedEmails: _vm.selectedEmails,
          isToolbarVisible: _vm.selectedEmails.length > 0
        },
        on: {
          closeToolbar: _vm.handleCloseMassActions,
          "open:related": _vm.handleOpenLinkObjectDialogFromMassActions
        }
      }),
      _vm._v(" "),
      _c("LinkObjectDialog", {
        attrs: {
          isVisible: _vm.showLinkObjectDialog,
          related: _vm.relatedObjects,
          isLoading: _vm.linkObjectDialogLoading,
          hasError: _vm.hasRelatedUpdateError,
          emptyStateData: _vm.emptyStateData
        },
        on: {
          close: _vm.handleCloseLinkObjectDialog,
          "update:related": _vm.updateRelatedObjects
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }